import { QueryConfig } from "store/utils/query-config";

export const customerCreditVouchersDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["issuedAt"],
  },
};

export function customerCreditVouchersQueryForContact(
  contactId: string
): QueryConfig {
  return {
    query: { contactId },
    options: { sortBy: ["issuedAt"] },
  };
}

export function customerCreditVouchersQueryForActiveContact(
  contactId: string
): QueryConfig {
  return {
    query: {
      contactId,
      status: { $in: ["ACTIVE", "PARTIALLY_REDEEMED"] },
      remainingBalance: { $gt: 0 },
    },
    options: {
      sortBy: ["expiresAt", "issuedAt"],
    },
  };
}
